"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
var React = require("react");
var typestyle_1 = require("typestyle");
var Container = (function (_super) {
    __extends(Container, _super);
    function Container() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Container.prototype.render = function () {
        var borderless = this.props.borderless ? "Container--borderless" : "";
        var fullWidth = this.props.fullWidth ? "Container--fullWidth" : "";
        return (React.createElement("div", { className: (0, typestyle_1.classes)("Container", borderless, fullWidth) },
            (this.props.containerTitle != null) &&
                React.createElement("div", { className: "Container__Header" },
                    React.createElement("h4", null, this.props.containerTitle)),
            (this.props.containerSubTitle != null) &&
                React.createElement("div", { className: "Container__Header" },
                    React.createElement("h5", null, this.props.containerSubTitle)),
            React.createElement("div", { className: "Container--no_border" }, this.props.children)));
    };
    return Container;
}(React.Component));
exports.Container = Container;
